export default {
    async createFormDataFromResponse(response) {
        let formData = {
            optionalReasons: []
        }
        for (const reason of response.optionalReasons) {
            formData.optionalReasons.push(reason.id);
        }

        return formData;
    }
};